import type { inferRouterOutputs, inferRouterInputs } from "@trpc/server";
import type { AppRouter } from "svc-auction";
import { ListAuctionInputSchema } from "svc-auction/src/routes/sales";

type RouterOutput = inferRouterOutputs<AppRouter>;
type RouterInput = inferRouterInputs<AppRouter>;

export type BidsList = RouterOutput["auctions"]["orders"]["list"];

export enum PaymentMethod {
  CRYPTO = "crypto",
  CREDIT_CARD = "creditCard",
}

export type PackStockList = RouterOutput["pack"]["stock"]["list"];
export type PackStock = PackStockList[number];
export type BuyPackResponse = RouterOutput["pack"]["buy"];

export type ReferralProgressionResponse = RouterOutput["users"]["referrals"]["get"];
export type AuctionsResponse = RouterOutput["auctions"]["list"];
export type ListUserSkillDeck = RouterInput["nfts"]["skills"]["userDeck"];

export type MarketPlaceFilter = Omit<
  ListAuctionInputSchema,
  "limit" | "page" | "statuses" | "types"
>;

export type TopBurnerResponse = RouterOutput["fusion"]["ranking"];
export type CreditListResponse = RouterOutput["users"]["credits"]["list"];

export type FlashSaleGetResponse = RouterOutput["flashSales"]["get"];
export type LoginWithWalletResponse = RouterOutput["auth"]["wallet"]["login"];

export type SalesHistoryResponse = RouterOutput["sales"]["history"]["list"];
